import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ColDef, GridApi, GridOptions } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { DeviationService } from "src/app/shared/services/deviation.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";

@Component({
    selector: "app-capa",
    templateUrl: "./capa.component.html",
    styleUrls: ["./capa.component.scss"],
    standalone: false
})
export class CapaComponent implements OnInit {
  @Input() capas: any[] = [];
  @Input() deviationId?: number;

  @Output() capasChange = new EventEmitter<any[]>();
  @Output() formOpenChange = new EventEmitter<boolean>();
  @Output() capaValidityChange = new EventEmitter<boolean>();


  showForm = false;
  capaForm: FormGroup;
  gridOptions: GridOptions = {};
  gridApi!: GridApi;
  editIndex: number | null = null;

  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {};
  backgroundColorButton = "";
  components: any;
  actionType: any[] = [
    { id: 1, lookupvalue: "corrective" },
    { id: 2, lookupvalue: "preventive" },
    { id: 3, lookupvalue: "detective" },
  ];
  private readonly LS_DEVIATION_ID = 'ACTIVE_DEVIATION_ID';
    isEditMode = false;
    selectedCapaId: string | null = null;


  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private jsignalsService: JsignalService,
    private deviationService: DeviationService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
    this.initializeGrid();
    this.createForm();
    this.loadCapa();
  }

  initializeGrid() {
    // Set theme colors
    this.backgroundColorButton =
      this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [
      {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: false,
        cellRenderer: "jsignalButton",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          //below value is passed to button to hide check box for deleted rows
          disableCheckBox: params.data?.status === "No",
          PopUpEdit: this.EditIcon.bind(this),
          PopUpDelete: this.deleteIcon.bind(this),
        }),
      },
      {
        headerName: "Name",
        field: "capaName",
        ...this.jsignalsService.autoTooltip("Name"),
        flex: 1,
      },
      {
        headerName: "Action Type",
        field: "actionType",
        ...this.jsignalsService.autoTooltip("Action Type"),
        flex: 1,
      },
      {
        headerName: "Due Date",
        field: "dueDate",
        ...this.jsignalsService.autoTooltip("Due Date"),
        flex: 1,
      },
      {
        headerName: "Description",
        field: "capaDescription",
        ...this.jsignalsService.autoTooltip("Description"),
        flex: 2,
      },
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };
  }

  createForm() {
    this.capaForm = this.fb.group({
      capaName: ["", Validators.required],
      capaDescription: ["", Validators.required],
      actionType: ["", Validators.required],
      dueDate: [null, Validators.required]
    });
  }

  private loadCapa(): void {
  const deviationId = this.deviationId || localStorage.getItem(this.LS_DEVIATION_ID);
  console.log(deviationId);

  if (!deviationId) {
    this.snackBar.open(
      'Deviation must be saved before adding Root Causes.',
      'Ok',
      { duration: 4000 }
    );
    return;
  }

  this.spinner.start();

  this.deviationService.getCapas(deviationId).subscribe({
    next: (res:any) => {

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }

      this.spinner.stop();

      this.capas = res || [];
      // this.rootCausesChange.emit(this.rootCauses);
      this.capaValidityChange.emit(this.capas.length > 0);

      if (this.gridApi) {
        this.gridApi.setGridOption('rowData', this.capas);
      }
    },
    error: () => {
      this.spinner.stop();
      this.handleFailure();
    }
  });
}

  addCAPAS() {
    this.isEditMode=false;
    this.selectedCapaId=null;
    // this.capaForm.reset();
    this.showForm = true; // hide grid, show form
    this.formOpenChange.emit(true); // hide parent button when form is open
    this.capasChange.emit(this.capas);
    console.log(this.capas);
  }

  saveCapa() {
    if (this.capaForm.invalid) {
      this.capaForm.markAllAsTouched();
      return;
    }

    this.spinner.start();

  const payload = {
  ...this.capaForm.value,
  dueDate: this.jsignalsService.toYYYYMMDD(this.capaForm.value.dueDate)
};

  
  console.log(payload);

  this.spinner.start();

  if (this.isEditMode) {
    this.updateCapa(payload);
  } else {
    this.createCapa(payload);
  }


    // this.capasChange.emit(this.capas);

    this.showForm = false;
    this.formOpenChange.emit(false);

    this.editIndex = null;
    this.capaForm.reset();

    this.gridApi.setGridOption('rowData', this.capas);
    this.spinner.stop();
  }

  private createCapa(payload: any): void {

  this.deviationService
    .addCapas(this.deviationId, [payload])
    .subscribe({
      next: (res:any) => {

      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }
        this.handleSuccess(res)
      },
      error: () => this.handleFailure()
    });
}

private updateCapa(payload: any): void {

  if (!this.selectedCapaId) return;

  this.deviationService
    .updateCapa(this.deviationId, this.selectedCapaId, payload)
    .subscribe({
      next: (res:any) => {

        if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }
        this.handleSuccess(res)
      },
      error: () => this.handleFailure()
    });
}

  cancelForm() {
    this.resetForm();
    this.editIndex = null;
    this.capaForm.reset();
    this.showForm = false;
    this.formOpenChange.emit(false);
  }

  private resetForm(): void {
  this.showForm = false;
  this.isEditMode = false;
  this.selectedCapaId = null;
  this.capaForm.reset();
  this.formOpenChange.emit(false);
}

  deleteIcon(params: any) {
  const row = params.rowData;
  if (!row?.id) return;

  this.spinner.start();

  this.deviationService
    .deleteCapa(this.deviationId, row.id)
    .subscribe({
      next: (res:any) => {
      if (res.error) {
        this.handleFailure(res); //backend message shown
        return;
      }
        this.handleSuccess(res)
        this.loadCapa();
      },
      error: () => this.spinner.stop()
    });
  }

  EditIcon(params: any) {
   const row = params.rowData;
  if (!row) return;

  this.isEditMode = true;
  this.selectedCapaId = row.id;

    // Patch form with existing values
    this.capaForm.patchValue({
      capaName: row.capaName,
      capaDescription: row.capaDescription,
      actionType: row.actionType,
      dueDate:row.dueDate
    });

    this.showForm = true; // hide grid, show form
    this.formOpenChange.emit(true); // hide parent button
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  private handleFailure(res?: any): void {
  this.spinner.stop();

  const message =
    res?.statusMessage ||
    'Operation failed. Please try again.';

  this.snackBar.open(message, 'Ok', {
    duration: 4000
  });

  this.clearDeviationState();
}

clearDeviationState() {
  localStorage.removeItem(this.LS_DEVIATION_ID);
  this.capas = [];
}
private handleSuccess(res: any): void {
  if (res && res.error === false) {
    this.snackBar.open(res.statusMessage, 'Ok', {
      duration: 3000
    });
  }
  this.loadCapa();
}

errorStateMatcher = {
  isErrorState: (control: any) => {
    return !!(
      control &&
      control.invalid &&
      (control.touched || control.dirty)
    );
  }
};
  
}
